import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import language from '../../variables/language';

// Multi-select word search: typeahead dropdown against GET /api/words?search=
// (à la ParticipantSearchSelect) that adds removable chips (à la TagsEditor),
// except each chip carries a real word id, not a free-text string. `value` is
// an array of {id, word}; `onChange` receives the full next array.
export default function WordMultiSearchSelect({ value, onChange, placeholder }) {
   const [query, setQuery] = useState('');
   const [results, setResults] = useState([]);
   const [open, setOpen] = useState(false);
   const wrapRef = useRef(null);
   const lang = language[language.lang];

   useEffect(() => {
      const handleOutside = (e) => {
         if(wrapRef.current && !wrapRef.current.contains(e.target)) {
            setOpen(false);
         }
      };
      document.addEventListener('mousedown', handleOutside);
      return () => document.removeEventListener('mousedown', handleOutside);
   }, []);

   // debounced server search - unlike ParticipantSearchSelect's one-shot
   // /api/students fetch, /api/words?search= is a real per-keystroke DB query
   useEffect(() => {
      if(!query.trim()) {
         setResults([]);
         return;
      }
      const timeout = setTimeout(() => {
         axios.get('/api/words', { params: { search: query.trim() }, withCredentials: true })
            .then(response => setResults(Array.isArray(response.data) ? response.data : []))
            .catch(() => setResults([]));
      }, 250);
      return () => clearTimeout(timeout);
   }, [query]);

   const selectedIds = new Set(value.map(w => w.id));
   const filtered = results.filter(w => !selectedIds.has(w.id));

   const handlePick = (word) => {
      onChange([...value, { id: word.id, word: word.word }]);
      setQuery('');
      setResults([]);
      setOpen(false);
   }
   const handleRemove = (id) => onChange(value.filter(w => w.id !== id));

   return (
      <div className='word-multi-search-select' ref={wrapRef}>
         <div className='word-multi-search-chips'>
            {value.map(w => (
               <span className='word-multi-search-chip' key={w.id}>
                  {w.word}
                  <span className='word-multi-search-chip-remove' onClick={() => handleRemove(w.id)}>×</span>
               </span>
            ))}
         </div>
         <input className='word-multi-search-input'
            type='text' placeholder={placeholder}
            value={query}
            onFocus={() => setOpen(true)}
            onChange={(e) => { setQuery(e.target.value); setOpen(true); }} />
         {open && query.trim() ? (
            <div className='word-multi-search-dropdown'>
               {filtered.length === 0 ? (
                  <div className='word-multi-search-empty'>{lang['Empty list']}</div>
               ) : filtered.map(w => (
                  <div key={w.id} className='word-multi-search-option' onClick={() => handlePick(w)}>
                     {w.word}
                  </div>
               ))}
            </div>
         ) : ''}
      </div>
   );
}
